var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhaiyao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 2.44a.5.5 0 00-.5.5v3.8a.5.5 0 00.5.5h3.8a.5.5 0 00.5-.5v-3.8a.5.5 0 00-.5-.5H2.1zm.5 3.8v-2.8h2.8v2.8H2.6zm-.5 2.55a.5.5 0 00-.5.5v3.8a.5.5 0 00.5.5h3.8a.5.5 0 00.5-.5v-3.8a.5.5 0 00-.5-.5H2.1zm.5 3.8v-2.8h2.8v2.8H2.6zM8 3.114a.5.5 0 01.5-.5h5.4a.5.5 0 010 1H8.5a.5.5 0 01-.5-.5zm.5 5.9a.5.5 0 000 1h5.4a.5.5 0 000-1H8.5zm-.5 3.86a.5.5 0 01.5-.5h5.4a.5.5 0 010 1H8.5a.5.5 0 01-.5-.5zm.5-6.9a.5.5 0 100 1h5.4a.5.5 0 000-1H8.5z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zhaiyao.b3679ec4.svg";
export { SvgTongyongZhaiyao as ReactComponent };